// interface Props {}
import { AboutWrapper } from './styled';
import { selectAboutPage } from './selectors';
import { useSelector } from 'react-redux';

function About() {
  const about = useSelector(selectAboutPage);

  return (
    <AboutWrapper id="about">
      <div className="aboutContent">
        <div className="--content">
          <div className="--img">
            <img src="/static/img/cover-1.jpeg" alt="" />
            <h2 className="--title">{about?.data?.title}</h2>
          </div>
          <article
            dangerouslySetInnerHTML={{
              __html: about?.data?.content || '',
            }}
          />
        </div>
      </div>
    </AboutWrapper>
  );
}

export default About;
